import { createContext } from "react";

// Create default shape for each field
export const ColorContext = createContext({
    // FRACTAL palette colors
    white: "",
    darkPurple: "",
    lightPurple: "",
    pink: "",
    yellow: "",
    blue: ""
})